import { ResetPasswordTypes } from './types'; // eslint-disable-line import/named
import {
    RESET_PASSWORD_LOAD_FAILED,
    RESET_PASSWORD_LOAD_SUCCEEDED,
    RESET_PASSWORD_LOAD_REQUESTED,
    RESET_PASSWORD_RESET_STATE
} from './constants';

export interface ResetPasswordState {
    error: string;
    submitted: boolean;
}

const initialState: ResetPasswordState = {
    error: '',
    submitted: false
};

function resetPasswordReducer(
    state: ResetPasswordState = initialState,
    action: ResetPasswordTypes
): ResetPasswordState {
    switch (action.type) {
        case RESET_PASSWORD_LOAD_REQUESTED:
            return {
                ...state,
                error: '',
                submitted: false
            };
        case RESET_PASSWORD_LOAD_FAILED:
            return {
                ...state,
                error: action.error
            };
        case RESET_PASSWORD_LOAD_SUCCEEDED:
            return {
                ...state,
                error: '',
                submitted: true
            };
        case RESET_PASSWORD_RESET_STATE:
            return initialState;
        default:
            return state;
    }
}

export default resetPasswordReducer;
